var version = {
    "name":      "dativery",
    "buildDateCode": "20260227-171024",
    "buildDate": "Fri Feb 27 2026 17:10:24 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260227-171024",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;